import React from "react";
import { PageLayout } from "../components/PageLayout";
import { BuildYourOwn } from "../features/products/BuildYourOwn";

export const BuildYourOwnPage: React.FC = () => {
  return <PageLayout>
    <BuildYourOwn />
  </PageLayout>;
};